// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Privacy_wrap_3QSMk","section":"Privacy_section_3JXi_","heading1":"Privacy_heading1_2yykl"};